"use client";

import { type ReactNode } from "react";
import { useLinkStatus } from "next/link";
import { PiCircleNotch } from "react-icons/pi";

/**
 * The label of a button inside a next/link, swapped for a spinner while the
 * page it opens is loading. The button needs `relative`.
 */
export function LinkPendingLabel({ children }: { children: ReactNode }) {
  const { pending } = useLinkStatus();

  return (
    <>
      <span className={pending ? "opacity-0" : undefined}>{children}</span>
      {pending ? (
        <PiCircleNotch
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 m-auto animate-spin"
        />
      ) : null}
      <span role="status" className="sr-only">
        {pending ? "Laster" : null}
      </span>
    </>
  );
}
